import {useContext} from "react";
import {useQuery} from '@tanstack/react-query';
import {API_URLS, axiosRequest} from "@lib/axios";
import UserContext from "@lib/contexts/userContext";

/**
 * React Query wrapper for Session participants
 */
const useParticipantDetailsQuery = (participant_id) => {
  const { authenticated } = useContext(UserContext);

  return useQuery({
    queryKey: ['participant', participant_id],
    queryFn: async () => axiosRequest({
      method: 'GET',
      url: `${API_URLS.PARTICIPANTS}/${participant_id}`
    }),
    enabled: authenticated,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useParticipantDetailsQuery;
